"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = exports.spacing = exports.border = exports.primaryTextAlt = exports.primaryText = exports.primaryBackground = void 0;
const colors_1 = require("./colors");
exports.primaryBackground = {
    backgroundColor: colors_1.colors.primaryBlue100,
};
exports.primaryText = {
    color: colors_1.colors.primaryBlue100,
};
exports.primaryTextAlt = {
    color: colors_1.colors.primaryBlue75,
};
exports.border = {
    radius: {
        xsmall: '6px',
        small: '12px',
        medium: '16px',
        large: '24px',
        xlarge: '40px',
    },
    style: '1px solid',
};
exports.spacing = { unit: 8 };
exports.shadows = {
    default: '0px 4px 120px rgba(47, 169, 238, 0.4)',
    medium: '0px 4px 80px rgba(47, 169, 238, 0.4)',
    small: '0px 2px 60px rgba(47, 169, 238, 0.4)',
    glow: '0px 4px 120px 0px rgba(47, 169, 238, 0.4)',
};
//# sourceMappingURL=common.js.map